import { render, staticRenderFns } from "./dateWeek.vue?vue&type=template&id=0b6a3bca"
import script from "./dateWeek.vue?vue&type=script&lang=js"
export * from "./dateWeek.vue?vue&type=script&lang=js"
import style0 from "./dateWeek.vue?vue&type=style&index=0&id=0b6a3bca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports